'use strict';

const libPictView = require('pict-view');

/**
 * UserActivity — the #/UserActivity[/:IDUser] screen. A per-user temporal "create pressure" view: how many
 * Observations, Documents, Comments and Document-Approval actions a user created (or updated) per day/week/month.
 *
 * Thin shell (SuperUserGrant/ManageCustomers style): all data + logic + HTML live in the shared
 * ActivityObservability provider, which renders into #AO-UserActivity-Body and owns the Chart.js canvas.
 */
class UserActivity extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ActivityObservability; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._ensureStyles();
			tmpProvider.renderUserActivity();
			// Base route (no :IDUser) — default to the signed-in user. The :IDUser sub-route pre-sets IDUser and
			// loads explicitly, so skip the auto-load when a user is already targeted.
			if (!tmpProvider.userActivity.IDUser && !tmpProvider.userActivity.Loading) { tmpProvider.loadUserActivityAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = UserActivity;
module.exports.default_configuration =
{
	ViewIdentifier: 'UserActivity',
	// Reusable app-shell Dashboard Mode — render full browser width (see PlatformConfiguration-Router _applyDashboardMode).
	DashboardMode: true,
	DefaultRenderable: 'UserActivityWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: '',
	Templates:
	[
		{
			Hash: 'UserActivity-Wrap',
			Template: /*html*/`
				<div class="ao-wrap">
					<div class="ao-head">
						<h1 class="ao-title">User Activity</h1>
						<p class="ao-subtitle">A user&#8217;s record-creation pressure over time — Observations, Documents, Comments and Document Approval actions, bucketed by day, week or month.</p>
					</div>
					<div id="AO-UserActivity-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'UserActivityWrap',
			TemplateHash: 'UserActivity-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
